import { ServerResponseData } from 'app/models/api/response';
import { BaseParser } from 'app/services/api/parsers/base-parser';
import { ParserMap } from 'app/services/api/parsers/response-parser';
import { Locale } from 'app/models/api/locale';

export class LocaleParser extends BaseParser {
    parse(data: ServerResponseData, _included: ServerResponseData[], _parsersMap: ParserMap) {
        const item = super.parseBase(Locale, data);
        return item;
    }
}
